import { RemoteTrack } from "livekit-client";

/**
 * Konkord: livekit runs a loop on every frame of the screen (60 to 240 times
 * a second, on a fast monitor) for each remote track, voices included, asking
 * the receiver for its timing only to fire TrackEvent.TimeSyncUpdate, which
 * Konkord never listens to (docs/reports/Otimizacao da transmissao.md, item
 * 6). Off here, before any track exists; nothing else reads what it kept
 */
export function stopTimeSyncLoop() {
  (
    RemoteTrack.prototype as unknown as { registerTimeSyncUpdate(): void }
  ).registerTimeSyncUpdate = () => {};
}

stopTimeSyncLoop();
